<template>
  <div id="app" :style="{minHeight: `${fullHeight}px`}">
    <transition :name="trans">
      <router-view :key="$route.path"/>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data() {
    return {
      trans: 'route-fade'
    }
  },
  methods: {
    ...mapActions(['setVersion', 'findHeight']),
  },
  mounted() {
    this.setVersion();
    this.findHeight()
  },
  computed: mapGetters(['fullHeight']),
  created() {
    window.addEventListener("resize", this.findHeight);
  },
  watch: {
    $route(to, from){
      let t = to.meta.orderNum
      let f = from.meta.orderNum

      if(t < f){
        this.trans = 'route-fade-back'
      }else{
        this.trans = 'route-fade'
      }
    }
  },
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $dark;
  font-size: 1rem;
  height: 100%;
  transition: height 250ms;
}

.route-fade-enter-active, .route-fade-leave-active {
  transition: all 500ms;
}
.route-fade-enter {
  transform: translateX(100%);
  opacity: 0;
}

.route-fade-leave-to{
  transform: translateX(-100%);
  position: absolute;
  opacity: 0;
}

.route-fade-back-enter-active, .route-fade-back-leave-active {
  transition: all 500ms;
}
.route-fade-back-enter {
  transform: translateX(-100%);
  opacity: 0;
}

.route-fade-back-leave-to{
  transform: translateX(100%);
  position: absolute;
  opacity: 0;
}

.scale-out-enter-active, .scale-out-leave-active {
  transition: all 500ms;
}
.scale-out-leave-to {
  position: absolute;
  transform: scale(0);
  opacity: 0;
}

</style>
